<template>
  <div id="dashboard-container">
      <md-app-drawer id="config-drawer" md-swipable :md-active.sync="menuVisible" :md-right=true>
        <md-toolbar class="md-transparent" md-elevation="0">
            <span class="md-title">Configure Strata Dashboard</span>
        </md-toolbar>
        <configuration-panel></configuration-panel>
      </md-app-drawer>
      <div v-if="!error" class="md-layout">
        <div id="result-map" v-show="!dashMaximized" :class="mapClasses">
            <result-map></result-map>
        </div>
        <div :class="dashboardClasses">
          <dashboard-panel></dashboard-panel>
        </div>
      </div>
      <div id="error-panel" v-else><h2>No data found</h2></div>
  </div>
</template>

<script>
import ConfigurationPanel from "@/components/OADashboard/ConfigurationPanel.vue"
import ResultMap from "@/components/OADashboard/ResultMap.vue"
import DashboardPanel from "@/components/OADashboard/DashboardPanel.vue"

export default {
  name: 'OADashboard',
  computed: {
    blocks(){
      return this.$store.getters['dashboard/getBlocks'];
    },
    menuVisible:{
      get(){
        return this.$store.getters['dashboard/isMenuVisible'];
      },
      set(val){
        this.$store.commit('dashboard/setMenuVisible', val);
      }
    },
    error(){
      return this.$store.getters['dashboard/isError'];
    },
    dashMaximized() {
      return this.$store.getters['dashboard/isDashMaximized'];
    },
    mapClasses() {
      if(this.dashMaximized){
        return ""
      }
      else {
        return "md-layout-item md-large-size-60 md-medium-size-60 md-small-size-100 md-xsmall-size-100"
      }
    },
    dashboardClasses() {
      if(this.dashMaximized){
        return "md-size-100"
      }
      else {
        return "md-layout-item md-large-size-40 md-medium-size-40 md-small-size-100 md-xsmall-size-100"
      }
    }
  },
  components: {
    ConfigurationPanel,
    ResultMap,
    DashboardPanel,
  },
  mounted(){
    this.$store.dispatch('dashboard/loadBlocks');
  },
  created() {
    this.$on('md-closed', () => {
        this.$store.commit('dashboard/setMenuVisible', false);
    });
    this.$root.$on('menu-clicked', () => {
        this.$store.commit('dashboard/setMenuVisible', !this.menuVisible);
    });
    window.addEventListener('beforeunload', () => {
       this.$store.emit('oa-dashboard-reload');
    })
  }
}
</script>

<style lang="scss" scoped>
#error-panel {
  margin: 20px;
}
@media screen and (max-width: 1024px) {
  #result-map {
    padding: 0 8px 0 8px;
  }
  .md-drawer {
    width: 80vw;
    max-width: 100vw;
  }
  .md-layout {
    margin-right: 0px;
    padding-right: 0px;
  }
}
</style>
